module.exports = __webpack_public_path__ + "img/icon-service-system-6.508cd758.svg";